import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import FadeIn from "react-fade-in";
import { useTranslation } from "react-i18next";
import { LeftMenuItems } from "../../../../config/leftMenuItems";

import { useEffect, useState } from "react";
import LeftSideBarSubItem from "./leftSideBarSubItem";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
const LeftSideBar = (props: any) => {
  const { currentPathConfiguration } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigation = useLocation();
  const item: any = currentPathConfiguration.path.replace("/", "");
  let SubItem: any = navigation.pathname.split("/")[3] || "";
  SubItem = SubItem?.includes("_") ? SubItem?.replace(/_/g, "") : SubItem; //To enable selected highlight for items with "_" in url

  const navigateTo = (nav: string) => {
    navigate(`bvoice/${nav}`, { replace: true });
  };

  // added below code to filter sideBar apps in control manager for "user" role, remove everything before return to allow access to all apps

  const [leftMenuItems, setleftMenuItems] = useState(LeftMenuItems);

  const userSettings = useSelector(
    (state: RootState) => state?.Auth?.userSettings
  );

  const userApps = [
    "users",
    "calllogs",
    "SIP Accounts",
    "Cell Phones",
    "voicemail",
  ];
  console.log("subitem=>", item, SubItem, LeftMenuItems);

  useEffect(() => {
    if (
      userSettings?.roles_l?.length === 1 &&
      userSettings?.roles_l[0] === "user"
    ) {
      let copyLeftMenuItems = { ...leftMenuItems };
      copyLeftMenuItems.userapp = copyLeftMenuItems?.userapp?.filter((node) =>
        userApps?.includes(node?.item)
      );
      console.log("copyLeftMenuItems", copyLeftMenuItems);
      setleftMenuItems(copyLeftMenuItems);
    }
  }, [userSettings]);

  return (
    <div className="h-full max-xl:w-[48px] w-[220px] duration-200 ease-out  transition-all flex flex-row bg-primary-alpha-20 dark:bg-ternary text-ternary-text ">
      <div className="flex flex-col w-full bg-white  ">
        <div className="sm:pt-4">
          {item && (
            <FadeIn>
              {leftMenuItems[
                item as "control" | "system" | "settings" | "fax"
              ] &&
                leftMenuItems[
                  item as "control" | "system" | "settings" | "fax"
                ]?.map((node: any, index: number) => {
                  return (
                    <div
                      id={node?.item}
                      key={node?.item}
                      className={`${SubItem === node?.item.trim().toLowerCase().split(" ").join("") ? "bg-primary-alpha-40" : "hover:bg-primary-alpha-20"} p-2 flex  transition:1 relative cursor-pointer items-center`}
                    >
                      <div
                        className={`pl-2   ${node?.subItems ? "" : "overflow-hidden"}  w-full`}
                      >
                        {node?.subItems ? (
                          <LeftSideBarSubItem mainItem={node} />
                        ) : (
                          <div
                            onClick={() => navigateTo(node.path)}
                            className="flex items-center justify-start gap-2 "
                          >
                            <div className="text-primary">{node.icon}</div>
                            {t(node.displayName) as string}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </FadeIn>
          )}
        </div>
      </div>
    </div>
  );
};
export default LeftSideBar;
